import classNames from 'classnames'
import { JSX } from 'react'

import { FormNumberInput } from 'cng-common/features/form'
import { IFormInputProps } from 'cng-common/features/form/components/formInput/models'
import { IFormNumberInput } from 'cng-common/features/form/components/formNumberInput/models'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn<T> = (props: IFormInputProps<T>) => JSX.Element | null

const applyDisabled = <T,>(component: TComponentFn<T>) => {
  return (props: IFormInputProps<T>) => {
    const { isDisabled, className } = props
    const disabledTheme = isDisabled ? themesStyles.disabledInput : undefined

    return component({
      ...props,
      className: classNames(className, disabledTheme),
    })
  }
}

export const OnboardingFormNumberInput = (props: IFormNumberInput) =>
  applyDisabled(createComponentFn<IFormNumberInput & JSX.IntrinsicAttributes>(FormNumberInput))(
    props
  )
